import { FormUtility } from "./FormUtility";
export function resolveFormPlaceholders(logger, formLoaderFactory) {
    var forms = FormUtility.getAllForms().filter(function (e) { return e.FormId && e.FormUrl && !e.UnboundForm; });
    var loader = formLoaderFactory();
    Promise.all(forms.map(function (form) { return loader.loadForm(form); })).then(function () { return logger.log("Forms loaded"); });
}
